module.exports = "<div class=\"search-bar-wrapper\">\n  <i class=\"search-bar-icon fa fa-search\"></i>\n  <input class=\"search-bar-input\" type=\"text\" matInput [formControl]=\"searchBar\" [matAutocomplete]=\"auto\" placeholder=\"Search here\">\n</div>\n<mat-autocomplete #auto=\"matAutocomplete\">\n  <mat-option *ngFor=\"let option of filteredOptions | async\" [value]=\"option\">\n    {{ option }}\n  </mat-option>\n</mat-autocomplete>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/system/core/top-navbar/search-bar/search-bar.component.html
// module id = ./src/app/system/core/top-navbar/search-bar/search-bar.component.html
// module chunks = main